// extracted by mini-css-extract-plugin
export default {"root":"mxZQ8"};